import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  state: {
    warehouseList: null,
  },
  getters: {
    getWarehouseList: state => state.warehouseList,
  },
  mutations: {
    successWarehouse: (state, payload) => {
      state.warehouseList = payload;
    },
  },
  actions: {
    getWarehouseList: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/warehouses/');

      commit('successWarehouse', result.response.result.rows);
      return result.response.result.rows;
    },

    updateWarehouse: async ({ commit, getters }, vehicle) => {
      const warehouse = {
        name: vehicle.name,
        vehicleType: vehicle.vehicleType,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/warehouses/${vehicle.id}`, warehouse);
      return result;
    },

    createEmptyWarehouse: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/warehouses');
      return result;
    },

    deleteWarehouse: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/warehouses/${id}`);
      return result;
    },

    deleteWarehouses: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/warehouses/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/warehouse.js